import { render, staticRenderFns } from "./BuscaArrematante.vue?vue&type=template&id=2562695d"
import script from "./BuscaArrematante.vue?vue&type=script&lang=js"
export * from "./BuscaArrematante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports